import { ArchiveMIPConfirmationModal } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageMip/MIPArchiveButton/ArchiveMIPConfirmationModal/ArchiveMIPConfirmationModal';
import { useMIPArchiveButton } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageMip/MIPArchiveButton/useMIPArchiveButton';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { Tooltip } from '@dealstack/frontend/shared/components/Tooltip/Tooltip';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	isDealArchived: boolean;
	isMIPArchived: boolean;
	programmeName: string;
	mipId: string;
	refetchMipData: () => void;
}

const MIPArchiveButton = ({
	isDealArchived,
	isMIPArchived,
	programmeName,
	mipId,
	refetchMipData,
}: Props) => {
	const {
		showArchiveMIPConfirmationModal,
		setShowArchiveMIPConfirmationModal,
		onSubmit,
		isAnyInvestorActive,
	} = useMIPArchiveButton(mipId, isMIPArchived, refetchMipData);

	const archiveButton = isMIPArchived ? (
		<ArchiveButtonWrapper>
			<Button
				variant="delete"
				onClick={() => setShowArchiveMIPConfirmationModal(true)}
				disabled={isDealArchived}
			>
				Unarchive Investment Programme
			</Button>
			{isDealArchived ? (
				<Tooltip
					tooltip={
						"This Programme cannot be unarchive, because it's Deal is still archived"
					}
					iconSize="lg"
				/>
			) : null}
		</ArchiveButtonWrapper>
	) : (
		<Button variant="delete" onClick={() => setShowArchiveMIPConfirmationModal(true)}>
			Archive Investment Programme
		</Button>
	);

	return (
		<div>
			{archiveButton}
			{showArchiveMIPConfirmationModal && (
				<ArchiveMIPConfirmationModal
					onClose={() => setShowArchiveMIPConfirmationModal(false)}
					programmeName={programmeName}
					isMIPArchived={isMIPArchived}
					onSubmit={onSubmit}
					isAnyInvestorActive={isAnyInvestorActive}
				/>
			)}
		</div>
	);
};

const ArchiveButtonWrapper = styled.div`
	display: flex;
`;
const _MIPArchiveButtonExport = memo(MIPArchiveButton);

export { _MIPArchiveButtonExport as MIPArchiveButton };
